export enum ClassificacaoOperacaoEnum {
  COMODATO = 'COMODATO',
  DEPRECIACAO = 'DEPRECIACAO',
  BAIXA = 'BAIXA',
  ESTORNO = 'ESTORNO',
  INVENTARIO = 'INVENTARIO',
  REAVALIACAO = 'REAVALIACAO',
  TOMBAMENTO = 'TOMBAMENTO',
  CORRECAO = 'CORRECAO',
  OUTROS = 'OUTROS',
  TRANSFERENCIA_CATEGORIA = 'TRANSFERENCIA_CATEGORIA'
}

export const classificacaoOperacaoFormatada = {
  COMODATO: 'Comodato',
  DEPRECIACAO: 'Depreciação',
  BAIXA: 'Baixa',
  ESTORNO: 'Estorno',
  INVENTARIO: 'Inventário',
  REAVALIACAO: 'Reavaliação',
  TOMBAMENTO: 'Tombamento',
  CORRECAO: 'Correção',
  OUTROS: 'Outros',
  TRANSFERENCIA_CATEGORIA: 'Transferência de Categoria'
};
